// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + chunkId + "." + {"4b893635-802":"fe67d9f63000d43c58ef","4b893635-422":"40571ad23849ad3f8b00"}[chunkId] + ".js";
};